require('../bootstrap');

import env from '../config/loadEnv';
import router from '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;
const portalUrl = env.portalAdmin;
const apiInvitee = env.apiInvitee;

const store = {
    state: {
        mode: '',
        user: {
            name: '',
            photo: '',
            job: '',
            email: '',
            is_admin: '',
            id: 0
        },
        authenticated: false,
        token: '',
        api: baseURL,
        url: normalURL,
        portalUrl: portalUrl,
        apiInvitee: apiInvitee,
        breadcrumbs: [{ name: "Home", route: "/" }],
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        },
        mode: state => {
            return state.mode;
        }
    },
    mutations: {
        auth(state, token) {

            if (token != null && token != undefined) {
                state.authenticated = true;
                state.token = token;

                localStorage.clear();
                localStorage.setItem('token', token);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then(response => {
                    state.user = response.data

                    localStorage.setItem('accept_terms', response.data.accept_terms);
                    localStorage.setItem('access_nivel', '3');

                })
                .catch(error => {
                    localStorage.clear();

                    router.push('/login');
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        },
    },
    actions: {
        initialize(context) {

            var self = this

        },
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js